import React from 'react';
import { Col } from '../../../lib/utils';
import { Body3Bold, CaptionRegular } from '../../../lib/font';
import { colors } from '../../../lib/colors';

const BulletText: React.FC<{ children: React.ReactNode }> = ({ children }) => (
    <CaptionRegular style={{ color: colors.LAVEL_3, lineHeight: '20px', marginTop: 6, paddingLeft: 8 }}>
        · {children}
    </CaptionRegular>
);

const RefundPolicySection: React.FC = () => {
    return (
        <Col
            style={{
                width: '100%',
                backgroundColor: '#FFFFFF',
                borderRadius: 16,
                padding: '24px 20px',
                boxShadow: '0 2px 12px rgba(0, 0, 0, 0.06)',
            }}
        >
            <Body3Bold style={{ color: colors.LAVEL_4 }}>환불 규정 안내</Body3Bold>
            <BulletText>
                환불 신청은 등록한 센터에서만 가능하며, 각 센터의 환불 정책이 적용됩니다.
            </BulletText>
            <BulletText>
                해당 센터에 직접 방문하여 현장 결제하는 이용권과 동일한 서비스입니다.
            </BulletText>
            <Body3Bold style={{ color: colors.LAVEL_4, marginTop: 20 }}>유의사항</Body3Bold>
            <BulletText>
                Rappo는 센터와 회원 간 결제를 지원하는 플랫폼으로, 수강권 판매의 직접 당사자가 아닙니다.
            </BulletText>
        </Col>
    );
};

export default RefundPolicySection;
